import React, { Fragment } from "react";

import { Trans, useTranslation } from "react-i18next";
import { NavLink, useNavigate, useParams } from "react-router-dom";

import { TitleH2 } from "components/generic";
import {
  CardVacanciesDiv,
  PostVacanciesSection,
  JobBackDiv,
  PostTitle,
  JobDiv
} from "./styles";
import { VACANCIES_ROUTE } from "utils/constants";
import { ISeo } from "interfaces/interfaces";
import { ItemLink } from "pages/rootpage/styles";
import { HeaderSEO } from "components/headerSEO";
import { ArrowRightIcon } from "../../../../components/Icons/ArrowRight";
import { IconBack } from "../../../../components/Icons/Back";

export const CardVacancies: React.FC<{ keyPost: string; index: number }> = ({
  keyPost
}) => {
  const { t, i18n } = useTranslation(`vacancies/${keyPost}`);
  const navigate = useNavigate();

  let allowedLang = t("lang", { returnObjects: true });
  if (!!allowedLang.length) {
    if (!allowedLang.includes(i18n.language === "gb" ? "gb" : i18n.language))
      return null;
  }

  return (
    <CardVacanciesDiv
      onClick={() =>
        navigate(`/${i18n.language}${VACANCIES_ROUTE.slice(5)}/${keyPost}`)
      }
    >
      <TitleH2>
        {t("title")}
        {ArrowRightIcon}
      </TitleH2>
    </CardVacanciesDiv>
  );
};

export const PostVacancies: React.FC = () => {
  const { id } = useParams();
  const { t: t_main } = useTranslation("vacancies");
  const { t } = useTranslation(`vacancies/${id}`);

  const images: ImageData[] = t("images", { returnObjects: true });
  const links: React.ReactNode[] = (
    t("links", { returnObjects: true }) as string[]
  ).map((item) => (
    <ItemLink
      href={item!}
      target="_blank"
      style={{ fontSize: "20px", textDecoration: "underline" }}
    />
  ));

  interface ImageData {
    name: string;
    alt: string;
    position: number;
  }

  const textLines: string[] = t("text", { returnObjects: true });
  const seo = t("seo", { returnObjects: true }) as ISeo;

  return (
    <JobDiv>
      {seo && <HeaderSEO {...seo} />}
      <PostVacanciesSection>
        <JobBackDiv>
          <NavLink to={VACANCIES_ROUTE}>
            <>
              {IconBack}
              {t_main("vacancies.backToAll")}
            </>
          </NavLink>
        </JobBackDiv>
        <PostTitle>{t("title")}</PostTitle>
        {textLines.length &&
          textLines.map((item, num) => (
            <Fragment key={num}>
              {images.findIndex((item) => item.position === num) !== -1 && (
                <div>
                  <img
                    src={
                      (process.env.PUBLIC_URL as string) +
                      "/images/" +
                      images[images.findIndex((item) => item.position === num)][
                        "name"
                      ]
                    }
                    alt={t(
                      images[images.findIndex((item) => item.position === num)][
                        "alt"
                      ]
                    )}
                  />
                </div>
              )}

              <Trans
                t={t}
                i18nKey={"text." + num}
                parent="p"
                components={links as any}
              />
            </Fragment>
          ))}
      </PostVacanciesSection>
    </JobDiv>
  );
};
